export interface ChatPromptContextResourceDefinition {
  /**
   * Chave do id no bloco do prompt. Nome TÉCNICO, igual ao que as tools esperam.
   */
  readonly idKey: string;
  /**
   * O que a Iara deve fazer com o recurso. É a razão de o recurso existir no
   * bloco: sem a instrução, anunciar que "existe documentação" não muda a resposta.
   */
  readonly instruction: string;
  /**
   * Nome de produto, exibido no bloco do prompt.
   */
  readonly label: string;
}

/**
 * Fonte ÚNICA do que pode virar RECURSO de contexto para a Iara.
 *
 * Recurso não é lugar: é o que existe de consultável no que já está em foco.
 * Por isso mora numa lista separada de `CHAT_PROMPT_CONTEXT_ENTITIES` em vez de
 * ser mais um tipo de entidade — as entidades seguem a contenção do produto
 * (fluxo → etapa → card) e o consumidor toma a ÚLTIMA como "onde o usuário está".
 * Uma documentação entrando naquela lista disputaria esse posto e faria o chip
 * anunciar "Documentação" quando o usuário está olhando um card.
 *
 * Quem preenche isto é a API, não o client: o client sabe onde o usuário está
 * (deriva da URL), a API sabe o que existe ali (consulta o banco). Assim o sinal
 * não depende da tela visitada, não custa uma query extra no client e não é
 * falsificável por quem chama a mutation.
 */
export const CHAT_PROMPT_CONTEXT_RESOURCES = {
  pipeDocumentation: {
    idKey: 'pipe_documentation_id',
    // A tool é nomeada de propósito, e busca pelo `pipe_id` (não por este id, que
    // serve de versão/proveniência). Nomear evita a Iara cair em
    // `generate_pipe_documentation`, que é o retrato da configuração na hora — ou
    // seja, exatamente o "inferir pela estrutura" que a instrução manda evitar.
    instruction:
      'descrição autoritativa deste processo, já escrita e revisada; leia com a tool `get_pipe_generated_documentation` (argumento: o `pipe_id` acima) antes de inferir o funcionamento pela configuração do fluxo',
    label: 'Documentação gerada do fluxo',
  },
} as const satisfies Record<string, ChatPromptContextResourceDefinition>;

export type ChatPromptContextResourceType = keyof typeof CHAT_PROMPT_CONTEXT_RESOURCES;

export const CHAT_PROMPT_CONTEXT_RESOURCE_TYPES = Object.keys(
  CHAT_PROMPT_CONTEXT_RESOURCES,
) as ChatPromptContextResourceType[];
